import React, { Fragment } from 'react';
import { Row, Col, Table, Badge, Button } from 'reactstrap';
import formatedDate, { formattedDateTime } from '../../../../../utilities/formatedDate';
import { Warning } from '@mui/icons-material';
import { getFromLocalStorage } from '../../../../../hooks/useLocalStorage';
import { initiateCommissionRefund, initiateCustomerRefundPayment } from '../../../../../api';
import { toast } from 'react-toastify';


const SettlementDetails = ({ data, invoice, commission, communicationData, userWalletHistory, transactionDetails, commissionTransactionDetails, cNDetails, quotation, offlineTicketData }) => {
    console.log(data, 'document-data')
    console.log(invoice, 'invoice-data')
    console.log(commission, 'commission-data')
    console.log(communicationData, 'communicationData')
    console.log(userWalletHistory, 'userWalletHistory')
    console.log(transactionDetails, 'transactionDetails')
    console.log(commissionTransactionDetails, 'commissionTransactionDetails');
    console.log(cNDetails, 'cNDetails');
    console.log(quotation, 'quotation');
    console.log(offlineTicketData, 'offlineTicketData');

    const walletType = getFromLocalStorage('user')?.partnerInfo?.wallet_type;
    // console.log(walletType, 'walletType');

    const isWalletPayment = data?.payment_by === "WALLET";
    const isCustomerPG = data?.payment_by === "CUSTOMER_PG";
    const isInvoicePaid = invoice?.claim_status === "PAID" || invoice?.claim_status === "PENDING_FOR_COMMISSION" || invoice?.claim_status === "PENDING_FROM_FINANCE";
    const isMscClaim =
        invoice?.claim_status === "PAID" ||
        invoice?.claim_status === "PENDING_FROM_FINANCE";

    const refundEntry = userWalletHistory?.find(
        item => (item.CTYPE === "REFUND" || item.CTYPE === "POLICY_REFUND") && item.TYPE === "ADD"
    );

    const cpgPayment = communicationData?.find(
        item => (item.TYPE === "CUSTOMER_PAYMENT")
    )

    const isOfflineTicketPaid = !!offlineTicketData?.bank_receipt_number;

    const handleResync = async (data) => {
        const payload = {
            "commission_id": 123,
            "commission_unique_id": "COM123456",
            "document_id": 987,
            "amount": 100,
            "reason": "Customer cancellation"
        }
        try {
            const response = await initiateCommissionRefund(payload);
            const successMsg = response?.data?.result?.msg || response?.data?.msg || 'Refund initiated successfully';
            toast.success(successMsg);

        } catch (err) {
            toast.error(err?.response?.data?.error || 'Unable to initiate refund');
        }
    };

    const handleCPGResync = async (documentUniqueCode) => {

        try {
            const response = await initiateCustomerRefundPayment({
                document_unique_code: documentUniqueCode || ''
            });
            const successMsg = response?.data?.result?.msg || response?.data?.msg || 'Refund initiated successfully';
            toast.success(successMsg);

        } catch (err) {
            toast.error(err?.response?.data?.error || 'Unable to initiate refund');
        }
    };

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                    <Table>
                        <tbody>
                            {/* Always show */}
                            <tr>
                                <th>Payment Mode:</th>
                                <td className="text-right pr-5">{data?.payment_by === "WALLET" ? "WALLET" : JSON.parse(cpgPayment.txnId)?.bank_ref_num}</td>
                            </tr>

                            {isWalletPayment && (
                                <>
                                    <tr>
                                        <th>Wallet Type:</th>
                                        <td className="text-right pr-5">{walletType || "-"}</td>
                                    </tr>

                                    {/* <tr>
                                        <th>Invoice Paid:</th>
                                        <td className="text-right pr-5">
                                            <Badge
                                                color={isInvoicePaid ? "success" : ""}
                                            >
                                                {offlineTicketData?.bank_receipt_number ?? offlineTicketData?.bank_receipt_number ?
                                                    isInvoicePaid ? "Paid" : "-" : "-"}
                                            </Badge>
                                        </td>
                                    </tr> */}

                                    <tr>
                                        <th>Invoice Paid:</th>
                                        <td className="text-right pr-5">
                                            <Badge
                                                color={
                                                    isInvoicePaid || offlineTicketData?.bank_receipt_number
                                                        ? "success"
                                                        : ""
                                                }
                                            >
                                                {offlineTicketData?.bank_receipt_number
                                                    ? offlineTicketData.bank_receipt_number
                                                    : isInvoicePaid
                                                        ? "Paid"
                                                        : "-"}
                                            </Badge>
                                        </td>
                                    </tr>


                                    <tr>
                                        <th>MSC Claim:</th>
                                        <td className="text-right pr-5">
                                            <Badge color={isMscClaim ? "success" : ""}>
                                                {isMscClaim ? "YES" : "-"}
                                            </Badge>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>MSC Settled:</th>
                                        <td className="text-right pr-5">
                                            {invoice?.claim_status === "PAID" &&
                                                commission?.payment_status === "PAID"
                                                ? commission?.utr_number || "-"
                                                : "-"}
                                        </td>
                                    </tr>

                                    {/* <tr>
                                        <th>Invoice Payment PG Refund:</th>
                                        <td className="text-right pr-5">

                                            {data?.status === "CANCELLED"
                                                ? isInvoicePaid
                                                    ? commission?.payment_status === "PROCESSING"
                                                        ? "In Progress"
                                                        : commission?.payment_status === "PAID"
                                                            ? commission?.payment_utr
                                                            : commission?.payment_status || "-"
                                                    : "-"
                                                : "-"}
                                        </td>
                                    </tr> */}

                                    <tr>
                                        <th>Invoice Payment PG Refund:</th>
                                        <td className="text-right pr-5">
                                            {data?.status === "CANCELLED" && isInvoicePaid ? (
                                                commissionTransactionDetails?.status === "REFUND_COMPLETED" ? (
                                                    commissionTransactionDetails?.refund_response?.bank_ref_num
                                                ) : commissionTransactionDetails?.status === "REFUND_QUEUED" ? (
                                                    <Badge color="warning">Initiated</Badge>
                                                ) : commissionTransactionDetails?.status === "REFUND_IN_PROGRESS" ? (
                                                    <Badge color="warning">In Progress</Badge>
                                                ) : commissionTransactionDetails?.status === "REFUND_FAILED" ? (
                                                    <Button
                                                        className="mr-1 btnCustom"
                                                        outline
                                                        color="info"
                                                        size="sm"
                                                        onClick={() => handleResync(data)}
                                                    >
                                                        Resync
                                                    </Button>
                                                ) : (
                                                    "-"
                                                )
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </tr>

                                    {/* <tr>
                                        <th>Wallet Refund Date/Time:</th>
                                        <td className="text-right pr-5">
                                            {isInvoicePaid && userWalletHistory?.created_date && userWalletHistory?.CTYPE === "REFUND" &&
                                                userWalletHistory?.TYPE === "ADD"
                                                ? formattedDateTime(userWalletHistory.created_date)
                                                : "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Wallet Refund Amount:</th>
                                        <td className="text-right pr-5">
                                            {isInvoicePaid &&
                                                userWalletHistory?.CTYPE === "REFUND" &&
                                                userWalletHistory?.TYPE === "ADD"
                                                ? userWalletHistory?.updated_amount || "-"
                                                : "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Wallet Refund Status:</th>
                                        <td className="text-right pr-5">
                                            {isInvoicePaid ? (
                                                userWalletHistory?.CTYPE === "REFUND" &&
                                                    userWalletHistory?.TYPE === "ADD" ? (
                                                    <Badge color="success">
                                                        Success
                                                    </Badge>
                                                ) : (
                                                    <Badge color="warning">
                                                        Pending
                                                    </Badge>
                                                )
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </tr> */}


                                    <tr>
                                        <th>Wallet Refund Date/Time:</th>
                                        <td className="text-right pr-5">
                                            {(isInvoicePaid || data?.status === "CANCELLED") && refundEntry?.created_date
                                                ? formattedDateTime(refundEntry.created_date)
                                                : "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Wallet Refund Amount:</th>
                                        <td className="text-right pr-5">
                                            {(isInvoicePaid || data?.status === "CANCELLED")
                                                ? refundEntry?.updated_amount ?? "-"
                                                : "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Wallet Refund Status:</th>
                                        <td className="text-right pr-5">
                                            {(isInvoicePaid || data?.status === "CANCELLED") ? (
                                                refundEntry ? (
                                                    <Badge color="success">
                                                        Success
                                                    </Badge>
                                                ) : (
                                                    <Badge color="warning">
                                                        Pending
                                                    </Badge>
                                                )
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </tr>


                                    <tr>
                                        <th>Credit Note:</th>
                                        <td className="text-right pr-5">
                                            {invoice?.cn_number || "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Refund Amount:</th>
                                        <td className="text-right pr-5">
                                            {data?.status === "CANCELLED" && isInvoicePaid &&
                                                commissionTransactionDetails?.type === "REFUND"
                                                ? commissionTransactionDetails?.amount || "-"
                                                : "-"}
                                        </td>
                                    </tr>

                                    <tr>

                                        <th>Refund Type:</th>
                                        <td className="text-right pr-5">
                                            {data?.status === "CANCELLED" &&
                                                isInvoicePaid &&
                                                userWalletHistory?.some(
                                                    item => item.CTYPE === "REFUND" && item.TYPE === "ADD"
                                                )
                                                ? "MSC Refund"
                                                : "-"}
                                        </td>

                                    </tr>
                                    {/* <tr>
                                        <th>Refund Type:</th>
                                        <td className="text-right pr-5">
                                            {data?.status === "CANCELLED" && isInvoicePaid &&
                                                userWalletHistory?.CTYPE === "REFUND" &&
                                                userWalletHistory?.TYPE === "ADD"
                                                ? "MSC Refund"
                                                : "-"}
                                        </td>
                                    </tr> */}

                                </>
                            )}

                            {isCustomerPG && (
                                <>
                                    <tr>
                                        <th>Invoice Paid:</th>
                                        <td className="text-right pr-5">
                                            <Badge color={quotation?.cpgPaymentStatus === "PAID" ? "success" : "warning"}>
                                                {quotation?.cpgPaymentStatus === "PAID" ? "Paid" : "-"}
                                            </Badge>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>MSC Claim:</th>
                                        <td className="text-right pr-5">
                                            <Badge color={isMscClaim ? "success" : ""}>
                                                {isMscClaim ? "YES" : "-"}
                                            </Badge>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>MSC Settled:</th>
                                        <td className="text-right pr-5">
                                            {!isMscClaim ? (
                                                "-"
                                            ) : commission?.payment_status === "PAID" ? (
                                                commission?.utr_number
                                            ) : (
                                                <Badge color="warning">
                                                    {commission?.payment_status || "-"}
                                                </Badge>
                                            )}
                                        </td>
                                    </tr>
                                    {/* <tr>
                                        <th>MSC Settled:</th>
                                        <td className="text-right pr-5">
                                            {isMscClaim &&
                                                commission?.payment_status === "PAID" ? (
                                                commission?.utr_number
                                            ) : (
                                                <Badge color="warning">
                                                    { commission?.payment_status || "-"}
                                                </Badge>
                                            )}
                                        </td>
                                    </tr> */}

                                    <tr>
                                        <th>Document Refund (CPG):</th>
                                        <td className="text-right pr-5">
                                            {data?.status === "CANCELLED" &&
                                                communicationData?.[0]?.TYPE === "CUSTOMER_REFUND_PAYMENT" ? (
                                                communicationData?.[0]?.status === "REFUND_COMPLETED" ? (
                                                    <Badge color="success">Settled</Badge>
                                                ) : communicationData?.[0]?.status === "REFUND_INITIATED" ? (
                                                    <Badge color="warning">Initiated</Badge>
                                                ) : communicationData?.[0]?.status === "REFUND_IN_PROGRESS" ? (
                                                    <Badge color="warning">In Progress</Badge>
                                                ) : communicationData?.[0]?.status === "REFUND_FAILED" ? (
                                                    <Button
                                                        className="mr-1 btnCustom"
                                                        outline
                                                        color="info"
                                                        size="sm"
                                                        onClick={() => handleCPGResync(data?.document_unique_code)}
                                                    >
                                                        Resync
                                                    </Button>
                                                ) : (
                                                    "-"
                                                )
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Reference ID:</th>
                                        <td className="text-right pr-5">
                                            {data?.status === "CANCELLED"
                                                ? communicationData?.[0]?.TYPE === "CUSTOMER_REFUND_PAYMENT"
                                                    ? communicationData?.[0]?.status === "REFUND_COMPLETED"
                                                        ? communicationData[0]?.txnId?.bank_ref_num
                                                        : "-"
                                                    : "PENDING"
                                                : "-"}
                                        </td>
                                    </tr>

                                    {/* <tr> */}
                                    {/* <th>Customer Refund if CPG Payment:</th> */}
                                    { }
                                    {/* <Badge
                                                color={ */}
                                    {/* {data?.status === "CANCELLED" */}
                                    {/* // ? communicationData?.[0]?.TYPE === "CUSTOMER_REFUND_PAYMENT" */}
                                    {/* // ? communicationData?.[0]?.status === "REFUND_INITIATED" */}
                                    {/* // ? "INITIATED" */}
                                    {/* // : "warning" */}
                                    {/* // : "PENDING" */}
                                    {/* // : "NO"} */}
                                    {/* } */}
                                    {/* > */}
                                    {/* </Badge> */}
                                    {/* </td> */}
                                    {/* </tr> */}

                                    <tr>
                                        <th>Credit Note:</th>
                                        <td className="text-right pr-5">
                                            {data?.status === "CANCELLED" ? invoice?.cn_number : "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Refund Amount:</th>
                                        <td className="text-right pr-5">
                                            {communicationData?.[0]?.TYPE === "CUSTOMER_REFUND_PAYMENT" && communicationData?.[0]?.status === "REFUND_COMPLETED"
                                                ? JSON.parse(
                                                    communicationData[0].body
                                                        .replace(/^"|"$/g, "")
                                                        .replace(/\\"/g, '"')
                                                )?.amount
                                                : "-"}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Refund Type:</th>
                                        <td className="text-right pr-5">
                                            {data?.status === "CANCELLED" ? "CPG Refund" : "-"}
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default SettlementDetails;